import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// Todo: Blocked a frame with origin "http://localhost:8081" from accessing a cross-origin frame.
// Only appear on vue 3
// Open issue: https://github.com/nicolasbeauvais/vue-social-sharing/issues/290
import VueSocialSharing from 'vue-social-sharing';
import FontAwesomeIcon from '@/assets/fontawesome.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

import i18n from '@/assets/lang/i18n.js';

createApp(App)
	.use(router)
	.use(i18n)
	.use(VueSocialSharing)
	.component('font-awesome-icon', FontAwesomeIcon)
	.mount('#app');
